import urls from './urls';
import axios from 'axios';

class FoldersApi {
  addConversationToFolder(
    conversationId: string | number,
    folderId: string | number,
    isGroup: boolean,
    isInboxRetention: boolean
  ): Promise<any> {
    const url = urls.ADD_CONVERSATION_TO_FOLDER.replace('{conversationId}', conversationId.toString()).replace(
      '{folderId}',
      folderId.toString()
    );
    return axios.post(url, { isGroup, isInboxRetention }, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }

  removeConversationFromFolder(conversationId: string | number, folderId: string | number, isGroup: boolean): Promise<any> {
    const url = urls.REMOVE_CONVERSATION_FROM_FOLDER.replace('{conversationId}', conversationId.toString()).replace(
      '{folderId}',
      folderId.toString()
    );
    return axios.delete(url, { baseURL: urls.BASE_URL, headers: { isAnonymous: false }, data: { isGroup } }).then(res => res);
  }

  addOrRemoveSinggleConversationToMultipleFolder(conversationId: string | number, folders: any): Promise<any> {
    const url = urls.ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER.replace('{conversationId}', conversationId.toString());
    return axios.post(url, folders, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }

  getFolders(): Promise<any> {
    return axios.get(urls.GET_FOLDERS, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }

  createFolder(params: any): Promise<any> {
    const url = urls.CREATE_FOLDER;
    return axios.post(url, params, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }

  updateFolder(id: string | number, params: any): Promise<any> {
    const url = urls.UPDATE_FOLDER.replace('{id}', id.toString());
    return axios.put(url, params, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }

  deleteFolder(id: string | number): Promise<any> {
    const url = urls.DELETE_FOLDER.replace('{id}', id.toString());
    return axios.delete(url, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }
}

export default new FoldersApi();
